<template>
  <b-form novalidate>
    <div class="row">
      <div class="col-12">
        <validated-form-select name="category" :options="categories" label="Kategooria:"
                               placeholder="- Vali kategooria -"
                               v-model="category" validate="required" :validator="$validator"/>
        <div>
          <a href="#" class="btn btn-outline-danger" @click.prevent="selectFile">
            <span v-if="!dataUrl">Vali fail</span>
            <span v-else>Vali uuesti</span>
          </a>
          <span v-show="name"><strong>{{name}}</strong></span>
        </div>

        <button type="button" class="btn btn-primary float-right" @click="submit" :disabled="!dataUrl">Salvesta</button>

        <input ref="fileinput" type="file" accept="*" @change="fileSelected" tabindex=-1 style="display: none">
      </div>
    </div>
  </b-form>
</template>

<script>
  import ValidatedFormSelect from '@/components/ValidatedFormSelect'
  import gateway from '@/services/gateway'
  import {utils} from '@/services/Configuration'

  export default {
    name: 'DocumentUpload',
    props: ['clientId'],
    components: {ValidatedFormSelect},
    data() {
      return {
        dataUrl: null,
        name: null,
        categories: [],
        category: null
      }
    },
    created() {
      gateway.get("/classifiers?name=client.filecategory")
        .then(r => this.categories.splice(1, 0, ...utils.asSelectOptions(r.data)))
    },
    methods: {
      selectFile() {
        this.$refs.fileinput.dispatchEvent(new MouseEvent('click'))
      },
      fileSelected(event) {
        let component = this
        let reader = new FileReader();
        let file = event.target.files[0]

        this.name = file.name

        reader.onload = () => {
          component.dataUrl = reader.result;
          component.$refs.fileinput.value = ''
        }
        reader.readAsDataURL(file)
      },
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          let document = {name: this.name, category: this.category, content: this.dataUrl}
          gateway.post(`/clients/${this.clientId}/documents`, document).then(() => {
            this.$emit('done')
            this.$notifications.info('Dokument on salvestatud')
          })
        })
      }
    }
  }
</script>

<style scoped>
 img {
   height: 100px;
 }
</style>